module.exports = __webpack_public_path__ + "static/media/_DSC6090.5a3f0dcb.jpg";